import type { ProductGroupView } from '@/types';

import React from 'react';

import { HStack, Select, Text } from '@/components';
import { useTranslation } from '@/hooks';

type Props = {
  productData: ProductGroupView;
  handleSelectProduct: (value: number) => void;
  error?: string;
};

const SelectVariant: React.FC<Props> = ({
  productData,
  handleSelectProduct,
  error,
}) => {
  const { t } = useTranslation('pages.products');

  return (
    <HStack alignItems="flex-start">
      <Text
        lineHeight="50px"
        fontSize={{ base: 'xs', md: 'md' }}
        fontWeight={500}
      >
        {t('type')}:{' '}
      </Text>
      <Select
        style={{ width: '220px' }}
        error={error}
        options={productData.variant_products.map((variant) => ({
          label: variant.title,
          value: String(variant.code),
        }))}
        isCurve
        onChange={(e: { label: string; value: string }) =>
          handleSelectProduct(Number(e.value))
        }
      />
    </HStack>
  );
};

export default SelectVariant;
